const resources = {
  "en": {
    "dashboard": {
      "title": "Dashboard",
      "description": "Use one focused workspace to add new activity and check the live account picture without bouncing across the app.",
      "meta": "Capture new entries and review the refreshed account state in one place",
      "composer": {
        "title": "Add something new",
        "description": "Use these entry panels to record new money movement or set up another account without leaving the dashboard.",
        "income": {
          "kicker": "Income",
          "title": "Add income",
          "description": "Record a new inflow and refresh the live view right away."
        },
        "consumption": {
          "kicker": "Spending",
          "title": "Add spending",
          "description": "Capture a new expense without leaving the dashboard."
        },
        "recurrentExpense": {
          "kicker": "Recurring",
          "title": "Add recurrent expense",
          "description": "Create a recurring expense and keep the setup in the same entry area."
        },
        "account": {
          "kicker": "Accounts",
          "title": "Add account",
          "description": "Open a new account record and make it available to the rest of the app."
        }
      },
      "live": {
        "title": "Live account view",
        "description": "After each update, review the latest balances, accounts, incomes, and spending from the same workspace.",
        "balance": {
          "kicker": "Snapshot",
          "title": "Balance",
          "description": "Current balance snapshot for the connected accounts.",
          "widget": {
            "title": "Balance snapshot",
            "loadFailed": "Failed to load balance",
            "cash": "On hand:",
            "debt": "Debts:",
            "net": "Net balance:",
            "estimatedCash": "Estimated cash:",
            "estimatedDebt": "Estimated debt:",
            "estimatedNet": "Estimated net balance:",
            "partialTitle": "This snapshot is partially valued",
            "partialDescription": "Cross-currency cash and debt are being estimated in {{currency}}, but some balances cannot be valued with the current quote set. Totals reflect only the valuated subset.",
            "estimatedTitle": "This snapshot uses the new valuation model",
            "estimatedDescription": "Cross-currency cash and debt are estimated in {{currency}} from native account balances and current FX quotes.",
            "staleTitle": "This snapshot uses stale FX quotes",
            "staleDescription": "Cross-currency cash and debt are estimated in {{currency}}, but some FX quotes are stale. Totals may lag until refresh completes.",
            "degradedTitle": "This snapshot is partially degraded",
            "degradedDescription": "Cross-currency cash and debt are estimated in {{currency}}, but some FX quotes are missing or failed. Totals may be incomplete until refresh succeeds.",
            "rolloutTitle": "Explicit valuation mode is active",
            "rolloutDescription": "This account is inside the bounded balance rollout cohort. Balance totals now stay on the explicit valuation path by design."
          },
          "breakdown": {
            "title": "Balance breakdown",
            "cashTitle": "Cash balance",
            "debtTitle": "Debts",
            "netTitle": "Net balance",
            "accountItem": "{{institution}} ({{type}}):",
            "debtItem": "{{party}}:",
            "unnamedDebt": "Unnamed",
            "totalLabel": "Total:",
            "rolloutTitle": "Explicit valuation mode is active",
            "rolloutDescription": "This balance breakdown is being served through the bounded explicit valuation rollout."
          }
        },
        "accounts": {
          "kicker": "Registry",
          "title": "Accounts",
          "description": "Account registry with the latest refreshed values."
        },
        "incomes": {
          "kicker": "Activity",
          "title": "Incomes",
          "description": "Most recent income entries in the current runtime view."
        },
        "consumptions": {
          "kicker": "Activity",
          "title": "Spending",
          "description": "Recent spending entries refreshed after each successful mutation."
        }
      },
      "deadlinesTitle": "Top 5 deadlines",
      "deadlinesEmpty": "No deadlines yet",
      "manageDeadlines": "Open manager",
      "noCategoryData": "No category data available for this period."
    }
  },
  "uk": {
    "dashboard": {
      "title": "Дашборд",
      "description": "Один зібраний робочий екран, де можна швидко додавати нові операції й одразу бачити оновлений стан рахунків.",
      "meta": "Додавай нові записи та переглядай оновлений стан рахунків в одному місці",
      "composer": {
        "title": "Додати новий запис",
        "description": "Тут можна внести новий рух грошей або створити ще один рахунок, не залишаючи дашборд.",
        "income": {
          "kicker": "Доходи",
          "title": "Додати дохід",
          "description": "Зафіксуй нове надходження і відразу онови живий огляд."
        },
        "consumption": {
          "kicker": "Витрати",
          "title": "Додати витрату",
          "description": "Додай нову витрату, не залишаючи дашборд."
        },
        "recurrentExpense": {
          "kicker": "Регулярне",
          "title": "Додати регулярну витрату",
          "description": "Створи регулярну витрату і залишайся в тому самому блоці введення."
        },
        "account": {
          "kicker": "Рахунки",
          "title": "Додати рахунок",
          "description": "Створи новий запис рахунку і одразу зроби його доступним для решти застосунку."
        }
      },
      "live": {
        "title": "Живий стан рахунків",
        "description": "Після кожного оновлення тут можна відразу перевірити баланс, рахунки, доходи й витрати.",
        "balance": {
          "kicker": "Знімок",
          "title": "Баланс",
          "description": "Поточний знімок балансу для підключених рахунків.",
          "widget": {
            "title": "Знімок балансу",
            "loadFailed": "Не вдалося завантажити баланс",
            "cash": "В наявності:",
            "debt": "Борги:",
            "net": "Чистий баланс:",
            "estimatedCash": "Оціночна готівка:",
            "estimatedDebt": "Оціночний борг:",
            "estimatedNet": "Оціночний чистий баланс:",
            "partialTitle": "Цей знімок оцінений частково",
            "partialDescription": "Мультивалютна готівка та борг зараз оцінюються в {{currency}}, але частину балансів неможливо оцінити з поточним набором курсів. Підсумки відображають лише оцінену частину.",
            "estimatedTitle": "Цей знімок уже використовує нову модель оцінки",
            "estimatedDescription": "Мультивалютна готівка та борг оцінюються в {{currency}} на основі нативних балансів рахунків і актуальних FX-курсів.",
            "staleTitle": "Цей знімок використовує застарілі FX-курси",
            "staleDescription": "Мультивалютна готівка та борг оцінюються в {{currency}}, але частина FX-курсів застаріла. Підсумки можуть оновитися після refresh.",
            "degradedTitle": "Цей знімок частково деградований",
            "degradedDescription": "Мультивалютна готівка та борг оцінюються в {{currency}}, але частина FX-курсів відсутня або завершилась помилкою. Підсумки можуть бути неповними до успішного refresh.",
            "rolloutTitle": "Режим явної оцінки вже активний",
            "rolloutDescription": "Цей акаунт входить у bounded cohort для balance rollout. Підсумки балансу тепер навмисно лишаються на explicit valuation path."
          },
          "breakdown": {
            "title": "Структура балансу",
            "cashTitle": "Готівковий баланс",
            "debtTitle": "Борги",
            "netTitle": "Чистий баланс",
            "accountItem": "{{institution}} ({{type}}):",
            "debtItem": "{{party}}:",
            "unnamedDebt": "Без назви",
            "totalLabel": "Разом:",
            "rolloutTitle": "Режим явної оцінки вже активний",
            "rolloutDescription": "Цей breakdown балансу віддається через bounded explicit valuation rollout."
          }
        },
        "accounts": {
          "kicker": "Реєстр",
          "title": "Рахунки",
          "description": "Реєстр рахунків з останніми оновленими значеннями."
        },
        "incomes": {
          "kicker": "Активність",
          "title": "Доходи",
          "description": "Останні записи доходів у поточному живому перегляді."
        },
        "consumptions": {
          "kicker": "Активність",
          "title": "Витрати",
          "description": "Останні записи витрат, що оновлюються після кожної успішної мутації."
        }
      },
      "deadlinesTitle": "Топ-5 дедлайнів",
      "deadlinesEmpty": "Поки без дедлайнів",
      "manageDeadlines": "Відкрити керування",
      "noCategoryData": "Немає даних по категоріях за цей період."
    }
  }
};

export default resources;
